
    export default 
    {
    "h5_redirect": {
        "bind_tip": "Sei sicuro di volerti collegare all'account DSers utilizzando l'indirizzo e-mail { email }?"
    }
}